import React from "react";

import ReferralPanelBackground from "@svg/referral-panel-background";

import { LabeledControl } from "@replo/design-system/blocks/labeled-control/LabeledControl";
import { Input } from "@replo/design-system/components/input/Input";
import Lottie from "lottie-react";

import templateLoadingAnimation from "../template-loading-animation.json";

type InitialCreationLoadingStateProps = {
  templateName: string;
};

export const InitialCreationLoadingState = ({
  templateName,
}: InitialCreationLoadingStateProps) => {
  return (
    <div className="flex flex-col">
      <div>
        <h3 className="header-h5 text-default">Share Page</h3>
        <p className="text-sm text-muted">
          Anyone with the link can make their own copy!
        </p>
      </div>

      <div className="pt-4">
        <LabeledControl label="Page Name" size="base">
          <Input value={templateName} readOnly size="base" />
        </LabeledControl>
      </div>

      <div className="flex flex-col gap-1 pt-4">
        <div className="relative rounded-xl border-0.5 border-black/10 shadow-2xs overflow-hidden">
          <ReferralPanelBackground className="absolute inset-0 w-full h-full" />
          <div className="relative h-[93px]">
            <div className="relative flex flex-col gap-0.5 px-3 pb-1 justify-end h-full">
              <h4 className="header-h6 text-default">Share & Earn</h4>
              <p className="text-xs text-muted">for every click on your link</p>
            </div>
          </div>
          <div className="relative p-3">
            <div className="bg-white rounded-lg shadow-sm p-2 h-10 flex items-center gap-4">
              <div className="flex-1 min-w-0 text-shimmer text-muted text-xs pl-1">
                Getting your link ready...
              </div>
              <button
                type="button"
                disabled
                className="bg-default text-white text-xs font-medium rounded-md px-2 h-6 min-w-16 opacity-50"
              >
                Copy Link
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="pb-4 pt-4">
        <div className="border-b-0.5 border-border -mx-3" />
      </div>

      <div className="flex flex-col">
        <div className="text-sm pb-1">
          <h4 className="font-medium text-default">Your Page</h4>
        </div>
        <div className="aspect-square bg-gradient-to-r from-sheet to-[#ECECEC] rounded-lg overflow-hidden flex flex-col items-center justify-center gap-2">
          <div className="w-3/5">
            <Lottie animationData={templateLoadingAnimation} loop={true} />
          </div>
          <span className="text-sm text-muted text-shimmer">
            Fetching Preview...
          </span>
        </div>
      </div>
    </div>
  );
};
